export default __webpack_public_path__ + "static/media/2483.17452fee.svg";